import { Routes, Route } from 'react-router-dom';
import AuthLoginPage from '../pages/auth/login';
import AuthLoginEmailPage from '../pages/auth/email';
import KakaoAuthPage from "../pages/auth/kakao";
import GoogleAuthPage from '../pages/auth/google';

import OnboardingPage from '../pages/onboarding';
import AgentPage from '../pages/agent';
import InfosPage from '../pages/tasks/infos';
import PaymentsPage from '../pages/tasks/payments';
import ReservationsPage from '../pages/tasks/reservations';
import ProtectedRoute from '../components/auth/ProtectedRoute';

const AppRoutes = () => {
    return (
        <Routes>
            
            <Route 
                path="/auth/login" 
                element={
                    <AuthLoginPage />
                } 
            />

            <Route
                path="/auth/login/email"
                element={
                    <AuthLoginEmailPage />
                }
            />

            <Route
                path="/auth/kakao"
                element={
                    <KakaoAuthPage />
                } 
            />

            <Route 
                path="/auth/google" 
                element={
                    <GoogleAuthPage/>
                } 
            />


            <Route
                path="/onboarding"
                element={
                    <ProtectedRoute>
                        <OnboardingPage />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <AgentPage/>
                    </ProtectedRoute>

                }
            />

            <Route
                path='/tasks/infos'
                element={
                    <ProtectedRoute>
                        <InfosPage/>
                    </ProtectedRoute>
         
                }
            />

            <Route
                path='/tasks/payments'
                element={
                    <ProtectedRoute>
                        <PaymentsPage />
                    </ProtectedRoute>
          
                }
            />
            
            <Route
                path='/tasks/reservations'
                element={
                    <ProtectedRoute>
                        <ReservationsPage/>
                    </ProtectedRoute>
           
                }
            />

        </Routes>
    )
}

export default AppRoutes;